export default __webpack_public_path__ + "74e119f286d05c6f4a4a57a427ba8eb6.jpg";